interface HamburgerProps {
  color?: string;
  size?: number;
}

export function Hamburger({
  color = "var(--black)",
  size = 30,
}: HamburgerProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="3" y="4.25" width="18" height="1.5" rx="0.75" fill={color} />
      <rect x="3" y="11.25" width="18" height="1.5" rx="0.75" fill={color} />
      <rect x="3" y="18.25" width="18" height="1.5" rx="0.75" fill={color} />
    </svg>
  );
}
